import { useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'

const useReturnReasons = ({ returnPortalId, doInitialRequest, disabled }) => {
  const { data: returnReasons, loading: fetchingReturnReasons } = useFetch(
    () => configurationServices.getPortalReturnReasons({ returnPortalId, disabled }),
    {
      doInitialRequest: doInitialRequest,
    }
  )

  return {
    returnReasons: returnReasons || [],
    fetchingReturnReasons,
  }
}

export default useReturnReasons
